import { render, staticRenderFns } from "./SuccessCard.vue?vue&type=template&id=4230e63a&"
import script from "./SuccessCard.vue?vue&type=script&lang=ts&"
export * from "./SuccessCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports